export default "__VITE_ASSET__BPefYhGp__"